import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { Subject } from 'rxjs';
import { IngresoService } from '../../servicios/ingreso.service';

@Component({
  selector: 'app-encuesta-pregunta',
  templateUrl: './encuesta-pregunta.component.html',
  styleUrls: ['./encuesta-pregunta.component.css']
})
export class EncuestaPreguntaComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsPregunta: DataTables.Settings = {};
  dtOptionsGrupo: DataTables.Settings = {};

  public dtTriggerPregunta: Subject<any>;
  public dtTriggerGrupo: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = "";
  fechaHoy: string = ""; horaHoy: string = "";
  public vecProvincia = []; public vecCiudad = []; public vecParroquia = []; public vecProcede = [];
  public vecAddPregunta = []; public vecVerPregunta = []; vecEditaOpcion = [];
  public vecAddGrupo = []; public vecVerGrupos = [];
  public vecAsTipo = []; public vecAsGrupo = []; public vecAsPregunta = []; public vecAddAsigna = [];
  public vecVerAsPregunta = []; public vecVerAsOpcion = []; public vecVerAsOtros = [];

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvInsert: IngresoService, private cargando: LoaderComponent, private srvSelect: SeleccionService,
    private tools: ToolsService) { }

  ngOnInit() {
    this.dtTriggerPregunta = new Subject<any>();
    this.dtTriggerGrupo = new Subject<any>();

    this.dtOptionsPregunta[0] = this.tools.OpcionesTabla(10);
    this.dtOptionsGrupo[0] = this.tools.OpcionesTabla(10);

    this.calculoFecha();
    this.instanciaVariables();
    this.verPreguntas();
    this.verGruposPreguntas();
    this.verAtributosAsigna(); this.verAsignaciones();
    this.encabezado = "Pisicología educativa";
    this.nombreBeca = localStorage.getItem('modNom');
    this.verProvincias();
  }
  //CARGAR LOS ATRIBUTOS DE LAS PREGUNTAS A ASIGNAR
  async verAsignaciones() {
    this.vecVerAsPregunta = []; this.vecVerAsOpcion = []; this.vecVerAsOtros = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(8, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success)
      this.vecVerAsPregunta = resGrupo.encuesta;

    const resOpcion = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(9, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resOpcion.success)
      this.vecVerAsOpcion = resOpcion.encuesta;

    const resOtros = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(21, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resOtros.success)
      this.vecVerAsOtros = resOtros.encuesta;
  }
  //CARGAR LOS ATRIBUTOS DE LAS PREGUNTAS A ASIGNAR
  async verAtributosAsigna() {
    this.vecAsTipo = []; this.vecAsGrupo = []; this.vecAsPregunta = [];

    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(2, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success)
      this.vecAsGrupo = resGrupo.encuesta;

    const resPreg = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(4, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPreg.success)
      this.vecAsPregunta = resPreg.encuesta;

    const resTipo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(5, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resTipo.success)
      this.vecAsTipo = resTipo.encuesta;
  }

  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verGruposPreguntas() {
    var table2 = $('#tblGrupo').DataTable({
      destroy: true
    });
    table2.destroy();

    this.cargando.abrir();
    this.vecVerGrupos = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(1, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecVerGrupos = resGrupo.encuesta;
      this.dtTriggerGrupo.next();
    }
    this.cargando.cerrar();
  }
  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verPreguntas() {
    var table2 = $('#tblPregunta').DataTable({
      destroy: true
    });
    table2.destroy();

    this.vecVerPregunta = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(3, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecVerPregunta = resGrupo.encuesta;
      this.dtTriggerPregunta.next();
    }
  }
  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModAgregar(nombModal) {
    if (localStorage.getItem('insUser') == 'true') {
      this.instanciaVariables();
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModEditar(nombModal, objPreg, op) {
    if (localStorage.getItem('insUser') == 'true') {
      this.instanciaVariables();

      if (op == 1) {
        this.vecAddGrupo[0]['num'] = objPreg.intIdGrupo;
        this.vecAddGrupo[0]['nombre'] = objPreg.strNombre;
        this.vecAddGrupo[0]['detalle'] = objPreg.strDescripcion;
        this.vecAddGrupo[0]['estado'] = objPreg.intEstado;
      }
      if (op == 2) {
        this.vecAddPregunta[0]['num'] = objPreg.intIdPregunta;
        this.vecAddPregunta[0]['nombre'] = objPreg.strNombre;
        this.vecAddPregunta[0]['detalle'] = objPreg.strDescripcion;
        this.vecAddPregunta[0]['estado'] = objPreg.intEstado;
      }
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //REGISTRAR UN NUEVO GRUPO
  ingresoGrupo(opc) {
    this.gestionPreguntasEncuesta(this.vecAddGrupo[0]['nombre'], this.vecAddGrupo[0]['detalle'], this.vecAddGrupo[0]['estado'], localStorage.getItem('idPersona'),
      this.fechaHoy, 'na', 'na', 'na', this.vecAddGrupo[0]['num'], opc);
  }
  //REGISTRAR UN NUEVA PREGUNTA
  ingresoPregunta(opc) {
    this.gestionPreguntasEncuesta(this.vecAddPregunta[0]['numero'], this.vecAddPregunta[0]['nombre'], this.vecAddPregunta[0]['detalle'], this.vecAddPregunta[0]['estado'],
      localStorage.getItem('idPersona'), this.fechaHoy, 'na', 'na', this.vecAddPregunta[0]['num'], opc);
  }
  //REGISTRA UNA OPCION DE UNA PREGUNTA A SER ASIGNADA
  async ingresoAsignacion(opc) {
    if (opc == 3) {
      this.gestionPreguntasEncuesta(this.vecAddAsigna[0]['tipo'] == 3 ? 'Complete' : this.vecAddAsigna[0]['opcion'], '', 0, this.vecAddAsigna[0]['tipo'],
        this.vecAddAsigna[0]['estado'], localStorage.getItem('idPersona'), this.fechaHoy, this.vecAddAsigna[0]['grupo'], this.vecAddAsigna[0]['pregunta'], 3);
    }
    if (opc == 4) {
      this.gestionPreguntasEncuesta(this.vecAddAsigna[0]['idGrupo'], this.vecAddAsigna[0]['grupo'], this.vecAddAsigna[0]['pregunta'], this.vecAddAsigna[0]['estado'],
        localStorage.getItem('idPersona'), this.vecAddAsigna[0]['orden'], 'na', 'na', 'na', 4);
    }
  }
  //GESTIONA LAS ACTIVADES A REALIZAR SOBRE LAS PREGUNTAS INGRESAR - EDITAR
  gestionPreguntasEncuesta(param1, param2, param3, param4, param5, param6, param7, param8, param9, op) {
    this.srvInsert.ingresoEncuesta(param1, param2, param3, param4, param5, param6, param7, param8, param9, 'na', op).subscribe(res => {
      if (res.encuesta) {
        this.alerti.success('Datos registrados correctamente');
        if (op == 1 || op == 11) {
          this.verGruposPreguntas();
          this.verAtributosAsigna();
          this.cerrarModal();
        }
        if (op == 2 || op == 12) {
          this.verPreguntas();
          this.verAtributosAsigna();
          this.cerrarModal();
        }
        if (op == 3) {
          this.verOpcionRegistrada();
        }
        // if (op == 4) {
        //   this.ingresoAsignacion();
        // }
        if (op == 5) {
          this.verAsignaciones();
        }
      }
      else
        this.alerti.error('Error inesperado vuelva a intentar más tarde');
    });
  }

  //  ============================  FUNCIONES DE EDITAR OPCIONES DE RESPUESTA DE PREGUNTAS  ============================
  verModalEditaOpcion(objOpcion, nombModal, cual) {
    this.instanciaVariables();
    this.mr = this.modalService.open(nombModal);
    if (cual == 2) {
      this.vecEditaOpcion[0]['idOpcion'] = objOpcion.idOpcion;
      this.vecEditaOpcion[0]['pregunta'] = objOpcion.nombPregunta;
      this.vecEditaOpcion[0]['nombrOpcion'] = objOpcion.nombOpcion;
      this.vecEditaOpcion[0]['descOpcion'] = objOpcion.strDetalle;
      this.vecEditaOpcion[0]['tipoOpcion'] = objOpcion.idTipo;
      this.vecEditaOpcion[0]['estado'] = objOpcion.estOpcion;
      this.vecEditaOpcion[0]['visible'] = objOpcion = 1;
      this.vecEditaOpcion[0]['opInsertar'] = 14;
    }
    if (cual == 3) {
      this.vecEditaOpcion[0]['idOpcion'] = objOpcion.intIdOtroO;
      this.vecEditaOpcion[0]['pregunta'] = objOpcion.nombOtro;
      this.vecEditaOpcion[0]['nombrOpcion'] = objOpcion.strNombre;
      this.vecEditaOpcion[0]['descOpcion'] = objOpcion.strDetalle;
      this.vecEditaOpcion[0]['tipoOpcion'] = objOpcion.intTipo;
      this.vecEditaOpcion[0]['estado'] = objOpcion.intEstado;
      this.vecEditaOpcion[0]['visible'] = objOpcion = 1;
      this.vecEditaOpcion[0]['opInsertar'] = 16;
    }
  }
  editarOpcion() {
    this.srvInsert.ingresoEncuesta(this.vecEditaOpcion[0]['idOpcion'], this.vecEditaOpcion[0]['nombrOpcion'], this.vecEditaOpcion[0]['descOpcion'],
      this.vecEditaOpcion[0]['tipoOpcion'], this.vecEditaOpcion[0]['estado'], 'na', 'na', 'na', 'na', 'na', this.vecEditaOpcion[0]['opInsertar']).subscribe(res => {
        if (res.encuesta) {
          this.alerti.success('Datos registrados correctamente');
        }
        else
          this.alerti.error('Error inesperado vuelva a intentar más tarde');
      });
  }
  //ABRIR EL MODAL QUE PERMITE AGREGAR UN GRUPO DE PREGUNTAS
  verModAddDirecto(nombModal, objPreg) {
    if (localStorage.getItem('insUser') == 'true') {
      this.instanciaVariables();
      this.vecAddAsigna[0]['idGrupo'] = objPreg.idGP;
      this.vecAddAsigna[0]['tipo'] = objPreg.tipoPregunta;
      this.vecAddAsigna[0]['grupo'] = objPreg.grupoGP;
      this.vecAddAsigna[0]['pregunta'] = objPreg.idPreg;
      this.vecAddAsigna[0]['estado'] = objPreg.estPreg;
      this.vecAddAsigna[0]['orden'] = objPreg.intOrden;
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  verModAddDirectoOpcion(nombModal, objOpcion) {
    if (localStorage.getItem('insUser') == 'true') {
      this.instanciaVariables();

      this.vecEditaOpcion[0]['pregunta'] = objOpcion.nombPregunta;
      this.vecEditaOpcion[0]['nombrOpcion'] = objOpcion.nombOpcion;
      this.vecEditaOpcion[0]['idOpcion'] = objOpcion.idOpcion;
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  ingresoOtraOpcion() {
    this.srvInsert.ingresoEncuesta('', this.vecEditaOpcion[0]['otraOpcion'], this.vecEditaOpcion[0]['descOpcion'], 0, this.vecEditaOpcion[0]['idOpcion'],
      this.vecEditaOpcion[0]['tipoOpcion'], this.vecEditaOpcion[0]['estado'], localStorage.getItem('idPersona'), 'na', 'na', 15).subscribe(res => {
        if (res.encuesta) {
          this.alerti.success('Datos registrados correctamente');
          this.cerrarModal();
          this.instanciaVariables();
        }
        else
          this.alerti.error('Error inesperado vuelva a intentar más tarde');
      });
  }
  //VER LAS PROVINCIAS CARGADAS EN LA BASE DE DATOS DEL MÉDICO
  async verProvincias() {
    this.vecProcede = [];
    this.vecProcede.push({ provincia: 0, ciudad: 0, parroquia: 0 });
    this.vecProvincia = [];
    const resProv = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(2, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resProv.success) {
      this.vecProvincia = resProv.ciudad;
      this.vecProcede[0]['provincia'] = this.vecProvincia[0]['provId'];
      this.verCiudad();
    }
  }
  //VER LAS CIUDADES QUE PERTENECEN A UNA PROVINCIA SELECCIONADA EN LA BASE DE DATOS DEL MÉDICO
  async verCiudad() {
    this.vecCiudad = [];
    const resCiudad = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(3, this.vecProcede[0]['provincia'], 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCiudad.success) {
      this.vecCiudad = resCiudad.ciudad; console.log('.................................  ', this.vecCiudad)
      this.vecProcede[0]['ciudad'] = this.vecCiudad[0]['ciudadId'];
      this.verParroquia();
    }
  }
  //VER LAS PARROQUIAS QUE PERTENECEN A UNA CIUDAD SELECCIONADA EN LA BASE DE DATOS DEL MÉDICO
  async verParroquia() {
    this.vecParroquia = [];
    const resCiudad = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(4, this.vecProcede[0]['ciudad'], 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCiudad.success) {
      this.vecParroquia = resCiudad.ciudad;
      this.vecProcede[0]['parroquia'] = this.vecParroquia[0]['idParroquia'];
    }
  }
  //  ============================  FUNCIONES DE EDITAR OPCIONES DE RESPUESTA DE PREGUNTAS  ============================

  //VER LA ULTIMA OPCION REGISTRADA
  async verOpcionRegistrada() {
    const resOpcion = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(6, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resOpcion.success) {
      this.gestionPreguntasEncuesta(this.vecAddAsigna[0]['idGrupo'], this.vecAddAsigna[0]['tipo'], resOpcion.encuesta[0]['intIdOpcion'], this.vecAddAsigna[0]['estado'],
        this.vecAddAsigna[0]['estado'], localStorage.getItem('idPersona'), this.fechaHoy, 'na', 'na', 5);
    }
  }
  //INSTANCIAR VARIABLES
  instanciaVariables() {
    this.vecAddPregunta = []; this.vecAddGrupo = []; this.vecAddAsigna = []; this.vecEditaOpcion = [];
    this.vecAddPregunta.push({ num: 0, numero: 0, nombre: '', detalle: '', estado: 1 });
    this.vecAddGrupo.push({ num: 0, nombre: '', detalle: '', estado: 1 });
    this.vecAddAsigna.push({ idGrupo: 0, tipo: 0, opcion: '', grupo: 1, pregunta: 0, estado: 1, visible: 1, orden: 1 });
    this.vecEditaOpcion.push({ idOpcion: 0, pregunta: '', nombrOpcion: '', otraOpcion: '', descOpcion: '', tipoOpcion: '', estado: 1, visible: 0, opInsertar: 0 });
  }
  //FUNCIÓN QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  calculoFecha() {
    var hoy = new Date();
    var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
    var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
    var annohoy = hoy.getFullYear();

    this.fechaHoy = annohoy + "-" + meshoy + "-" + diahoy;
    this.horaHoy = hoy.getHours() + "_" + hoy.getMinutes();
  }
  cerrarModal() {
    this.mr.close();
  }
}
